export default __webpack_public_path__ + "c9f5febddbaf9cf15622622c42049006.png";